module.exports = __webpack_public_path__ + "img/2.f14d58a8.gif";